import { type ISelectProps } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { TaxSelect } from '@webapp/platform/finance'
import messages from './messages'
import { type StaticExpenseTaxOption } from './types/ExpenseTaxSelectValue'

export type IExpenseTaxSelectProps = ISelectProps

export const ExpenseTaxSelect = (props: IExpenseTaxSelectProps) => {
  const intl = useProcurifyIntl()

  const staticOptions: StaticExpenseTaxOption[] = [
    { id: '%', name: intl.formatMessage(messages.taxTypePercent) },
    { id: '$', name: intl.formatMessage(messages.taxTypeDollar) },
  ]

  return <TaxSelect extraOptions={staticOptions} {...props} />
}
